import React from 'react';
import { Table } from 'react-bootstrap';
import Row from './components/Row';

const EventsTable = ({ events, onUpdate, onRemove }) => {
    const rows = events.map((event) => <Row key={event.id} event={event} onUpdate={onUpdate} onRemove={onRemove} />);

    return (
        <Table bordered responsive>
            <thead>
            <tr>
                <th>Summary</th>
                <th>Description</th>
                <th>URL</th>
                <th>Alarm1 Trigger</th>
                <th>Alarm1 Description</th>
                <th>Alarm2 Trigger</th>
                <th>Alarm2 Description</th>
                <th>Action</th>
            </tr>
            </thead>
            <tbody>
            {rows}
            </tbody>
        </Table>
    );
};

export default EventsTable;


// WEBPACK FOOTER //
// ./src/scenes/CalendarEvents/components/Table/index.js